import Snap from 'snapsvg-cjs';
import enterView from 'enter-view';

function pieChart(el) {
  const pc = el;

  const rawData = JSON.parse(el.getAttribute('data-piechart'));
  const percentages = rawData.map((e) => e.stat_percentage);

  const width = 550;
  const height = 550;
  const minOfWH = Math.min(width, height);
  const origin = { x: minOfWH / 2, y: minOfWH / 2 };
  const thickness = minOfWH / 4;
  const strokeWidth = '1%';

  const padding = 30;
  const initialAnimDelay = 1000;
  const arcAnimDelay = 400;
  const arcAnimDur = 300;

  const arcs = [];

  const animationChart = Array.from(
    document.querySelectorAll('.animatePieChart'),
  );

  function sumArr(arr) {
    return arr.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
  }

  function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = ((angleInDegrees - 90.0) * Math.PI) / 180.0;

    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians),
    };
  }

  function createSegment(x, y, radius, segmentThickness, startAngle, endAngle) {
    const start = polarToCartesian(x, y, radius, endAngle);
    const end = polarToCartesian(x, y, radius, startAngle);
    const innerStart = polarToCartesian(
      x,
      y,
      radius - segmentThickness,
      startAngle,
    );
    const innerEnd = polarToCartesian(
      x,
      y,
      radius - segmentThickness,
      endAngle,
    );

    const arcSweep = endAngle - startAngle <= 180 ? '0' : '1';

    const d = [
      'M',
      start.x,
      start.y,
      'A',
      radius,
      radius,
      0,
      arcSweep,
      0,
      end.x,
      end.y,
      'L',
      innerStart.x,
      innerStart.y,
      'A',
      radius - segmentThickness,
      radius - segmentThickness,
      0,
      arcSweep,
      1,
      innerEnd.x,
      innerEnd.y,
      'L',
      start.x,
      start.y,
      'z',
    ].join(' ');

    return d;
  }

  function easeOutCubic(x) {
    return 1 - (1 - x) ** 3;
  }

  function hideSegments() {
    arcs.forEach((e) => {
      e.attr({
        transform: `r0,${origin.x},${origin.y}`,
        opacity: 0,
      });
    });
  }

  function animateChart() {
    hideSegments();

    const rotations = percentages.map(
      (e, i) => (100 - sumArr(percentages.slice(0, i + 1))) * 3.6,
    );

    arcs.forEach((e, i) => {
      setTimeout(
        () => {
          const transString = `r${rotations[i]},${origin.x},${origin.y}`;

          e.animate({ opacity: 1 }, arcAnimDur / 2).animate(
            { transform: transString },
            arcAnimDur,
            easeOutCubic,
          );
        },
        initialAnimDelay + arcAnimDelay * i,
      );
    });
  }

  const container = Snap(el);

  const chart = Snap(minOfWH, minOfWH).attr({
    viewBox: `0 0 ${minOfWH} ${minOfWH}`,
  });

  rawData.forEach((obj, i) => {
    let color;

    switch (obj.stat_colour) {
      case 'orange':
        color = '#FF6E33';
        break;
      case 'green':
        color = '#01B483';
        break;
      case 'blue-light':
        color = '#A4DBDE';
        break;
      case 'pink':
        color = '#FCBBE0';
        break;
      case 'grey':
        color = '#E2DEDD';
        break;
      case 'peach':
        color = '#F8A087';
        break;
      case 'charcoal':
        color = '#282829';
        break;
      default:
        color = '#ffffff';
    }

    arcs[i] = chart
      .path(
        createSegment(
          origin.x,
          origin.y,
          minOfWH / 2 - padding,
          thickness,
          0,
          obj.stat_percentage * 3.6,
        ),
      )
      .attr({
        fill: `${color}`,
        stroke: '#2A2A2A',
        strokeWidth,
        opacity: 0,
      });
  });

  container.add(chart);

  pc.removeAttribute('data-piechart');

  animationChart.length &&
    enterView({
      selector: animationChart,
      offset: 0,
      once: true,
      enter() {
        animateChart();
      },
    });

  pc.addEventListener('click', () => {
    animateChart();
  });
}

export function init() {
  const initPiecharts = (sourceElement = document) => {
    const elements = sourceElement.querySelectorAll('[data-piechart]');

    elements.length &&
      elements.forEach((el) => {
        pieChart(el);
      });
  };

  initPiecharts();

  $(window).on('module.reinit', (e, modalContentElement) => {
    initPiecharts(modalContentElement);
  });
}
